var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrumpet = function SvgTrumpet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.502.841a1.531 1.531 0 0 1 2.165 1.394v16.791a1.531 1.531 0 0 1-2.057 1.438l-8.14-2.975.937 8.43a1.678 1.678 0 0 1-1.667 1.863 2.049 2.049 0 0 1-1.976-1.506l-.034-.141-1.954-9.768-2.276.001a2.407 2.407 0 0 1-2.388-2.11l-.014-.15-.004-.146v-5.63A2.406 2.406 0 0 1 3.5 5.925h3.832L18.502.84ZM7.4 16.368h-.286l1.902 9.51c.07.343.371.59.722.59.18 0 .329-.128.36-.299l.005-.085-1.01-9.098-1.693-.618ZM19.304 2.095a.219.219 0 0 0-.259-.06L7.617 7.239H3.5c-.604 0-1.094.49-1.094 1.094v5.63c0 .604.49 1.094 1.094 1.094h4.133l11.428 4.176a.219.219 0 0 0 .294-.206V2.235a.22.22 0 0 0-.02-.09l-.031-.05Zm4.521 13.09.074.063 2.282 2.283a.656.656 0 0 1-.854.991l-.074-.063-2.282-2.283a.656.656 0 0 1 .854-.991Zm3.034-5.836a.656.656 0 0 1 .089 1.307l-.09.006h-3.423a.656.656 0 0 1-.09-1.307l.09-.006h3.424Zm-1.532-8.164a.656.656 0 0 1 .854.991L23.9 4.46l-.074.063a.656.656 0 0 1-.854-.991l2.282-2.283.074-.063Z",
    fill: "#191919"
  })));
};

export default SvgTrumpet;